/**
 * Shared styles and constants for data grid components
 * Used by JobsPipelinesTab and AddSchedules to eliminate duplication
 */

export const autocompleteSxProps = {
    '& .MuiInputBase-root': {
        pt: .5,
        pb: .2,
        px: 1
    }
};

export const autocompleteTextFieldProps = {
    sx: {
        '& .MuiOutlinedInput-root': {
            fontSize: '14px',
            fontWeight: '500',
            '& fieldset': {
                // !important tag is given becoz style is getting overridden by some css files
                borderColor: `rgba(113, 117, 143, 0.8) !important`
            },
            '&:hover fieldset': {
                borderColor: 'light.main'
            },
            '&.Mui-focused fieldset': {
                borderColor: 'light.main'
            }
        }
    }
};
